import React, { useEffect, useRef, useState } from 'react';
import { ParallaxLayer } from 'react-spring/renderprops-addons';
import useOnScreen from '../useOnScreen';
import './DNoizNetwork.scss';
import { fadeUp, fadeIn } from './animations/allTransitions';
import CountUp from './animations/CountUp';
import avatars from '../assetsV2/avatars';
// 用户弹幕数据
const userReviews = [
  {
    name: "Sarah Chen",
    avatar: avatars.avatar1,
    rating: 5,
    review: "NOIZ makes streaming a blast—fans engage more, tools are top-notch. Let’s keep this amazing partnership going!"
  },
  {
    name: "John Martinez",
    avatar: avatars.avatar2,
    rating: 4,
    review: "NOIZ rocks! The support, the growth—everything clicks. Let’s keep making awesome content together!"
  },
  {
    name: "Emma Wilson",
    avatar: avatars.avatar3,
    rating: 5,
    review: "My journey on NOIZ has been incredible—growth, fun, support. Let’s keep creating magic together!"
  },
  {
    name: "Takeshi Yamamoto",
    avatar: avatars.avatar4,
    rating: 4,
    review: "The experience on NOIZ is great. I'm definitely ready for more live streaming quests."
  },
  {
    name: "Alex Müller",
    avatar: avatars.avatar5,
    rating: 4,
    review: "Live quests on NOIZ feel effortless and fun. Loving the flow, eager for more opportunities!"
  },
  {
    name: "Lucas Silva",
    avatar: avatars.avatar6,
    rating: 5,
    review: "Quests here feel like a win-win. NOIZ gets creators, and I’m ready for way more!"
  },
  {
    name: "Yuki Tanaka",
    avatar: avatars.avatar7,
    rating: 4,
    review: "Every quest on NOIZ elevates my content. Loving the journey, need more opportunities!"
  },
  {
    name: "John Martinez",
    avatar: avatars.avatar8,
    rating: 4,
    review: "NOIZ's influencer reach is impressive. Quest execution is smooth. Looking forward to more campaigns!"
  },
  {
    name: "Emma Wilson",
    avatar: avatars.avatar9,
    rating: 5,
    review: "With NOIZ, quest management is a breeze. Their insights boost our brand. More quests, please!"
  },
  {
    name: "Takeshi Yamamoto",
    avatar: avatars.avatar10,
    rating: 4,
    review: "NOIZ connects us with the right gamers. Their quest system is efficient. Let's keep this up!"
  },
  {
    name: "Alex Müller",
    avatar: avatars.avatar11,
    rating: 4,
    review: "NOIZ nails quest - based marketing. Great for reaching gaming audiences. Let's partner further!"
  },
  {
    name: "Lucas Silva",
    avatar: avatars.avatar12,
    rating: 5,
    review: "Our brand thrives with NOIZ quests. Their platform is reliable. Time for another round!"
  },
  {
    name: "Yuki Tanaka",
    avatar: avatars.avatar13,
    rating: 4,
    review: "NOIZ's quest - based approach suits our brand well. Looking forward to future collaborations!"
  }
];

// 轨道配置
const TRACKS = 4;
const trackTops = [15, 28, 54, 80]; // 百分比

const DNoizNetwork = (props) => {
  const {
    pOffset,
    layoutFactor = 1,
    offsetAdjust = 0,
  } = props;
  const ref = React.createRef();

  const [holdIt, setHoldIt] = React.useState(false);
  const [barrages, setBarrages] = useState([]);
  const [liveUserCount, setLiveUserCount] = useState(50000);

  useEffect(() => {
    fetch('/api/v1/noiz/platform-stats')
      .then(r => r.json())
      .then(data => {
        if (data && data.userCount) {
          setLiveUserCount(Math.floor(data.userCount / 500) * 500);
        }
      })
      .catch(() => {});
  }, []);
  const barrageId = useRef(0);
  const trackStatus = useRef(Array(TRACKS).fill(false));

  const onScreen = useOnScreen(ref, '600px', 0.1);

  useEffect(() => {
    if (onScreen && !holdIt) {
      fadeUp('brand-d-writing-pod');
      fadeIn('brand-d-noiz-title');
      setTimeout(() => setHoldIt(true), 1400);
    }
  }, [onScreen, holdIt]);

  useEffect(() => {
    let timer;
    let initialTimeouts = [];
    function getFreeTrack() {
      for (let i = 0; i < TRACKS; i++) {
        if (!trackStatus.current[i]) return i;
      }
      return Math.floor(Math.random() * TRACKS); // 全部占用时随机
    }
    /* eslint-disable no-loop-func */
    function sendDanmaku() {
      // 限制最大弹幕数
      if (barrages.length >= TRACKS) return;
    
      // 随机选取不重复的用户
      let user;
      let reviewText; // 将 reviewText 的声明移入循环内部
      let tryCount = 0;
      do {
        user = userReviews[Math.floor(Math.random() * userReviews.length)];
        reviewText = user.review; // 每次循环重新赋值
        tryCount++;
        // 检查最近3条是否重复
      } while (
        // eslint-disable
        barrages.slice(-3).some(b => b.text === reviewText) &&
        tryCount < 10
      );
    
      if (tryCount >= 10) {
        console.warn("Failed to find a unique review after 10 attempts.");
        return; // 如果尝试了10次仍未找到唯一评论，直接退出
      }
    
      const duration = Math.random() * 5 + 8;
      const track = getFreeTrack();
      trackStatus.current[track] = true;
      const top = trackTops[track];
    
      setBarrages((prev) => [
        ...prev,
        {
          id: barrageId.current++,
          name: user.name,
          avatar: user.avatar,
          rating: user.rating,
          text: reviewText,
          top,
          duration,
          track
        }
      ]);
    }
    if (onScreen) {
      // 初始弹幕分批生成，避免堆叠
      for (let i = 0; i < TRACKS; i++) {
        initialTimeouts[i] = setTimeout(() => {
          sendDanmaku();
        }, i * 1200);
      }
      // 定时弹幕
      timer = setInterval(() => {
        sendDanmaku();
      }, Math.random() * 3000 + 2000);
    }
    return () => {
      clearInterval(timer);
      initialTimeouts.forEach(t => clearTimeout(t));
    };
  }, [onScreen, barrages.length]); // 添加 barrages.length 到依赖数组

  // 弹幕动画结束后移除并释放轨道
  const handleAnimationEnd = (id, track) => {
    setBarrages((prev) => prev.filter(item => item.id !== id));
    trackStatus.current[track] = false;
  };

  const showIt = onScreen || holdIt;

  return (
    <>
      <ParallaxLayer
        offset={pOffset + offsetAdjust}
        factor={layoutFactor}
        className="global-platform-background"
      >
      </ParallaxLayer>
      {/* 弹幕层 */}
      <ParallaxLayer
        offset={pOffset + offsetAdjust}
        factor={layoutFactor}
        className="danmaku-container"
      >
        {barrages.map((item) => (
          <div
            className={`danmaku rating-${item.rating}`}
            key={item.id}
            style={{
              top: `${item.top}%`,
              animationDuration: `${item.duration}s`
            }}
            onAnimationEnd={() => handleAnimationEnd(item.id, item.track)}
          >
            <img src={item.avatar} alt={item.name} className="danmaku-avatar" loading="lazy" />
            <span>{item.text}</span>
          </div>
        ))}
      </ParallaxLayer>
      <ParallaxLayer
        offset={pOffset + offsetAdjust}
        factor={layoutFactor}
        speed={0}
        className="brand-d-noiz-vcontainer"
      >
        {showIt && <div className="brand-d-noiz-title fade-up-prep" >
          The Noiz Global Network
        </div>}
        <div ref={ref} />
        <div className="brand-d-noiz-horiz-container" >
          {showIt && <div className="brand-d-writing-pod">
            <div className="brand-d-purple-counter" >
              <CountUp staticText="million" countNum={132} textPlacement="right" />
            </div>
            <div className="brand-d-subtitle" >
              Live Stream Reach
            </div>
          </div>}
          {showIt && <div className="brand-d-writing-pod">
            <div className="brand-d-purple-counter" >
              <CountUp countNum={liveUserCount} textPlacement="right" />
            </div>
            <div className="brand-d-subtitle" >
              Influencers
            </div>
          </div>}
          {showIt && <div className="brand-d-writing-pod">
            <div className="brand-d-purple-counter" >
              <CountUp countNum={150} textPlacement="right" />
            </div>
            <div className="brand-d-subtitle" >
              Countries
            </div>
          </div>}
          {showIt && <div className="brand-d-writing-pod">
            <div className="brand-d-purple-counter" >
              <CountUp staticText="million" countNum={60} textPlacement="right" />
            </div>
            <div className="brand-d-subtitle" >
              Social Reach
            </div>
          </div>}
        </div>
      </ParallaxLayer>
    </>
  );
};

export default DNoizNetwork;

